<div class="input-block">
  <input
    [type]="type"
    [attr.name]="name"
    [(ngModel)]="value"
    (blur)="onBlur()"
    [placeholder]="placeholder || ''"
    class="form-control" />
  <!-- <label
    class="input-block-placeholder"
    for="{{'input-' + name}}"
    [ngClass]="{'input-block-placeholder--active': inputValue && placeholder}">
    {{placeholder}}
  </label> -->
</div>